import TextInput from "Components/molecule/inputs/text-input"
import { ChangeEvent } from "react"
import ConsultantFields from "./types"
import SelectInput, { SelectOption } from "Components/molecule/inputs/select-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import RocksFields from "./types"
import DateInput from "Components/molecule/inputs/date-input"
import SearchSelect from "Components/molecule/inputs/search-select"
import TextAreaInput from "Components/molecule/inputs/textarea-inpuit"

interface RocksFormProps extends FormProps<RocksFields> {
    years: SelectOption[]
    quarters: SelectOption[]
    employees: SelectOption[]
    status?: SelectOption[]
}

const ACCOUNTABLE_KEY = 'accountableID'
const STATUS_KEY = 'statusId'
const QUARTER_KEY = 'quarter'
const YEAR_KEY = 'year'
const ROCKS_KEY = 'rocks'
const HELP_FROM_KEY = 'helpFrom'
const DATE_OF_COMPLETION_KEY = 'completedAt'
const DESCRIPTION_KEY = 'description'

const RocksForm = ({
    values,
    handleChange,
    handleBlur,
    years,
    quarters,
    employees,
    status,
    handleSubmit,
    isSubmitting,
    errors,
    isValid,
    touched,
    handleCancel,
    edit
}: RocksFormProps) => {
    return <div className="form-container">
        <div className="input-grid">
            <SearchSelect
                options={employees}
                name={ACCOUNTABLE_KEY}
                key={ACCOUNTABLE_KEY}
                label={"Accountable*"}
                placeholder={"Accountable"}
                value={values.accountableID}
                onChange={(e) => e?.value && handleChange(ACCOUNTABLE_KEY)(e.value)}
                onBlur={handleBlur(ACCOUNTABLE_KEY)}
                error={!!touched.accountableID && !!errors.accountableID}
                message={touched.accountableID ? errors.accountableID : undefined}
            />
            {edit && status &&
                <SearchSelect
                    name={STATUS_KEY}
                    key={STATUS_KEY}
                    label={"Status*"}
                    placeholder={"Status"}
                    value={values.statusId || ''}
                    onChange={(e) => e?.value && handleChange(STATUS_KEY)(e.value)}
                    onBlur={handleBlur(STATUS_KEY)}
                    error={!!touched.statusId && !!errors.statusId}
                    message={touched.statusId ? errors.statusId : undefined}
                    options={status}
                />
            }
            <SearchSelect
                options={years}
                name={YEAR_KEY}
                key={YEAR_KEY}
                label={"Year*"}
                placeholder={"Year"}
                value={values.year || ''}
                onChange={(e) => e?.value && handleChange(YEAR_KEY)(e.value)}
                onBlur={handleBlur(YEAR_KEY)}
                error={!!touched.year && !!errors.year}
                message={touched.year ? errors.year : undefined}
            />
            <SearchSelect
                name={QUARTER_KEY}
                options={quarters}
                key={QUARTER_KEY}
                label={"Quarter*"}
                placeholder={"Quarter"}
                value={values.quarter}
                onChange={(e) => e?.value && handleChange(QUARTER_KEY)(e.value)}
                onBlur={handleBlur(QUARTER_KEY)}
                error={!!touched.quarter && !!errors.quarter}
                message={touched.quarter ? errors.quarter : undefined}
            />
            <TextInput
                touched={!!touched.helpFrom}
                name={HELP_FROM_KEY}
                key={HELP_FROM_KEY}
                label={"Help From"}
                placeholder={"Who helped?"}
                value={values.helpFrom || ''}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.helpFrom && !!errors.helpFrom}
                message={touched.helpFrom ? errors.helpFrom : undefined}
            />
            {
                edit &&
                <DateInput
                    name={DATE_OF_COMPLETION_KEY}
                    key={DATE_OF_COMPLETION_KEY}
                    label={"Date Of Completion"}
                    placeholder={"email@company.com"}
                    value={values.completedAt || ''}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.completedAt && !!errors.completedAt}
                    message={touched.completedAt ? errors.completedAt : undefined}
                />
            }
            <TextAreaInput
                name={ROCKS_KEY}
                key={ROCKS_KEY}
                label={"Rocks*"}
                placeholder={"What is blocking the path?"}
                value={values.rocks}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.rocks && !!errors.rocks}
                message={touched.rocks ? errors.rocks : undefined}
                max={3000}
            />
            <TextAreaInput
                touched={!!touched.description}
                name={DESCRIPTION_KEY}
                key={DESCRIPTION_KEY}
                label={"Comments*"}
                placeholder={"Comments"}
                value={values.description || ''}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.description && !!errors.description}
                message={touched.description ? errors.description : undefined}
                max={1000}
            />
        </div>
        <div className="button-container">
            <PrimaryButton
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
            >
                {isSubmitting ? "Saving...." : "Save"}
            </PrimaryButton>
            {
                handleCancel &&
                <SecondaryButton
                    disabled={isSubmitting}
                    onClick={() => handleCancel()}
                >
                    Back
                </SecondaryButton>
            }
        </div>
    </div>
}

export default RocksForm